import React, { InputHTMLAttributes } from 'react';
import styles from './index.style.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  type: string;
  isDisabled?: boolean;
  className?: string;
  value?: string;
  ref?: React.Ref<HTMLInputElement>;
}

const Input = ({
  type = 'text',
  isDisabled = false,
  className = '',
  value = '',
  ref,
  ...rest
}: InputProps) => {
  return (
    <input
      type={type}
      disabled={isDisabled}
      className={`${className} ${styles.input}`}
      ref={ref}
      value={value}
      {...rest}
    />
  );
};

export default Input;
